import { render, staticRenderFns } from "./panel_tran.vue?vue&type=template&id=525d042d&scoped=true&"
import script from "./panel_tran.vue?vue&type=script&lang=js&"
export * from "./panel_tran.vue?vue&type=script&lang=js&"
import style0 from "./panel_tran.vue?vue&type=style&index=0&id=525d042d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525d042d",
  null
  
)

export default component.exports